import {
  article,
  job,
  researchProject,
  taxonomy
} from '@stereoagency/sanity-schema';
import { profileModalQueryBuilder } from '@/components/modals';

export const orderedArticleBuilder = article.schema.builder.orderBy(
  'datetime',
  'desc'
) as typeof article.schema.builder;

export const orderedJobBuilder = job.schema.builder.orderBy(
  'datetime',
  'desc'
) as typeof job.schema.builder;

export const orderedProjectsBuilder = researchProject.schema.builder.orderBy(
  'datetime',
  'desc'
) as typeof job.schema.builder;

export const relatedArticlesQuery = orderedArticleBuilder
  .filter('^._id in linkedResearchContent[]._ref')
  .pick(['_id', 'datetime', 'slug', 'title', 'introduction', 'thumbnail'])
  .map((resolver) => ({
    taxonomies: resolver.taxonomies
      .resolveIn(['_id', 'type', 'slug', 'name'])
      .use()
  }))
  .use();

export const relatedJobsQuery = orderedJobBuilder
  .filter('^._id in linkedResearchContent[]._ref')
  .pick(['_id', 'slug', 'datetime', 'title', 'description', 'location'])
  .map((resolver) => ({
    taxonomies: resolver.taxonomies.resolveIn(['_id', 'slug', 'name']).use()
  }))
  .use();

export const relatedProjectsQuery = orderedProjectsBuilder
  .filter('^._id == linkedResearchContent._ref')
  .pick(['_id', 'slug', 'title'])
  .map((resolver) => ({
    taxonomies: resolver.taxonomies
      .resolveIn(['_id', 'type', 'slug', 'name'])
      .use()
  }))
  .use();

export const departmentProfilesQuery = profileModalQueryBuilder
  .filter(
    `_id in [...^.departments[].value[].primaryMembers[].profile._ref, ...^.departments[].value[].otherMembers[].profile._ref]`
  )
  .use();

export const taxonomiesQuery = taxonomy.schema.builder
  .filter('_id in ^.taxonomies[]._ref')
  .pick(['_id', 'type', 'slug', 'name'])
  .use();

export const groupLeaderQuery = profileModalQueryBuilder
  .filter('_id == ^.researchGroupLeader._ref')
  .first()
  .use();

export const platformLeaderQuery = profileModalQueryBuilder
  .filter('_id == ^.researchPlatformLeader._ref')
  .first()
  .use();
